import { render, staticRenderFns } from "./excelOs.vue?vue&type=template&id=32b60a6a"
import script from "./excelOs.vue?vue&type=script&lang=js"
export * from "./excelOs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports